module.exports = __webpack_public_path__ + "static/media/IconButtonExcelUpload.44759eb9.svg";